export const en = {
    index: {
        header_1: 'What ',
        header_2: 'type of Storage',
        header_3: ' do you require?',
        select_option: 'Select an option to proceed',
        skip_button_text: 'Skip - Show me all prices',
        personal: 'Personal',
        business: 'Business',
        personalText: 'Store personal items, keepsakes and small furniture',
        businessText: 'Secure storage for business inventory, documents and equipment',
    },
    journey_bar: {
        step_1: 'Storage Type',
        step_2: 'Storage Size',
        step_3_a: 'Pricing',
        step_3_b: 'Booking',
        step_4: 'Confirm',
        step_5: 'Payment',
        step_6: 'Summary',
    },
    unit_listing: {
        header_1: 'How much ',
        header_2: 'space',
        header_3: ' do you require?',
        no_units: 'No Units',
        unit_unavailable_at_move_in: 'The unit is no longer available. Please select another unit to continue.',
    },
    book_unit: {
        header_1: 'Select a ',
        header_2: 'deal',
        header_3: ' below',
        deals: ' deals',
        inclusions: 'What\'s Included',
        click_to_view: 'Click to view',
    },
    customise_booking: {
        header_mobile: 'Select Options',
        upgrade: 'Upgrade',
        booking_details_error: 'We could not save your booking details. Please check them and try again.',
    },
    descriptor: {
        idealFor: 'Ideal For',
    },
    carousel: {
        smaller: 'Smaller',
        larger: 'Larger',
    },
    stack: {
        inclusions: 'What\'s Included',
    },
    labels: {
        small: 'SMALL',
        medium: 'MEDIUM',
        large: 'LARGE',
        or: 'Or',
        easiest_access: 'Easiest Access',
    },
    time: {
        per_week: 'Per Week',
        per_month: 'Per Month',
        per_week_short: '/wk',
        per_month_short: '/mo',
        per_4_weeks_short: '/4wks',
    },
    sizeSlider: {
        small: 'Small',
        medium: 'Medium',
        large: 'Large',
    },
    cta: {
        select: 'Select',
        continue: 'Continue',
        step_3: {
            continue: 'Continue',
        },
        enquire_now: 'Enquire Now',
        call_us_now: 'Call Us Now',
        cancel: 'Cancel',
        close: 'Close',
        bigger_unit: 'Need a bigger unit?',
        email_us: 'Email Us',
        call_us: 'Call Us',
    },
    unit_card: {
        no_price_chane: 'No Price Change',
        valued_at: 'Valued at',
        customise_booking: 'Customise Booking',
        alternative_unit_options: 'Alternative Unit Options',
        no_units_available: 'No units available',
        extra: 'Extra',
        save: 'Save',
    },
    coupon_code: {
        title: 'Promo Code / Coupon',
        apply: 'Apply',
        placeholder: 'Enter your promo or coupon code here',
        alerts: {
            success: 'Promo code applied successfully',
            error: 'Promo code expired or invalid',
        },
    },
    contact_card: {
        error: 'Error',
        error_text: 'An error has occured while submitting the form. Please try again or contact our site if this problem persists',
        phone: 'Phone',
        email: 'Email',
        first_name: 'First Name',
        last_name: 'Last Name',
        email_address: 'Email Address',
        move_in_date: 'Move In Date',
        phone_number: 'Phone Number',
        address: 'Address',
        postcode: 'Postcode',
        city: 'City',
        state: 'State',
        reservation: {
            title: 'Reservation',
            subtitle: 'Almost there! We just need a few more things to finalise your reservation.',
            success: 'Reserved!',
            success_detail: 'Thank you, your reservation has been successfully created.',
        },
        quote: {
            title: 'Quote Details',
            subtitle: 'Almost there! We just need a few more things then your personalised quote will be emailed to you.',
            success: 'Quote Sent!',
            success_detail: 'Thank you, your quote has been sent to your inbox.',
        },
        showPrices: {
            title: 'Show Prices',
            form_title: 'Show Prices',
            submit_text: 'Show Prices',
            subtitle: 'Almost there! We just need a couple more details to provide you with a personalised quote.',
        },
        contactMe: {
            title: 'Enquire Now',
            submit_text: 'Enquire Now',
        },
        largerUnit: {
            title: 'Enquire About a Larger Unit',
            form_title: 'Larger Unit Enquiry',
            submit_text: 'Send Enquiry',
            subtitle: 'Leave your details and we will contact you about a unit that fits.',
            success: 'Enquiry Sent!',
            success_detail: 'Thank you, we have received your enquiry and will be in touch soon.',
            message: 'This customer is looking for a larger unit than the sizes shown.',
            largest_size: 'Largest size shown',
        },
        privacy_policy: 'Privacy Policy',
        terms_and_conditions: 'Storage Terms and Conditions',
        invalid_email_domain: 'Please enter a valid email domain',
        required_fields: 'Please fill in all required fields',
    },
    wizard: {
        back: 'Back',
        booking: 'Booking',
        unitInformation: 'Unit Information',
        reservation: 'Reservation',
        scheduleMoveIn: 'Schedule your move-in',
        finalisingMoveIn: 'Finalising your move-in…',
        moveInPaymentSucceededButFailed: 'Your payment was received, but we couldn\'t complete your move-in. Please contact us so we can finish setting up your unit.',
        moveInProcessingTimeout: 'Your payment was received and your move-in is still being processed. Please contact us if it isn\'t confirmed shortly.',
        finalisingReservation: 'Finalising your reservation…',
        reservationFeePaymentSucceededButFailed: 'Your payment was received, but we couldn\'t complete your reservation. Please contact us so we can finish securing your unit.',
        reservationFeeProcessingTimeout: 'Your payment was received and your reservation is still being processed. Please contact us if it isn\'t confirmed shortly.',
        moveInErrorContactHeading: 'Need help? Please contact your store:',
        moveInErrorQuoteHeading: 'Please quote the following details when you get in touch:',
        moveInErrorPhone: 'Phone: {{phone}}',
        moveInErrorEmail: 'Email: {{email}}',
        moveInErrorName: 'Name: {{name}}',
        moveInErrorUnit: 'Unit: {{unit}}',
        copy: 'This reservation requires a fee to be paid. Please proceed through the steps to complete your reservation. During the process we will reserve a storage unit for you and send you an email with the details.',
        selectDate: 'Select a date you would like to move-in.',
        next: 'Next',
        confirm_booking: 'Confirm Booking',
        payViaFinverse: 'Pay via Finverse',
        process_paypal: 'Pay via PayPal',
        termsAndConditionsAgree: 'I agree to the terms and conditions',
        marketingAgree: 'Allow marketing',
        assistanceMovingAgree: 'I need assistance with a moving truck or trailer',
        dateOfBirth: 'Date of Birth',
        otherError: 'An unexpected error has occurred, please refresh and try again or contact support',
        autobill: 'Auto bill my card to avoid late fees',
        autobillUsePaymentDetails: 'Use payment details for autobilling',
        autobillRequired: 'Autobilling is required — please enable "Use payment details for autobilling"',
        autobillDetails: {
            title: 'Autobill',
            directDebit: 'Direct Debit',
            creditCard: 'Credit Card',
            bsbNumber: 'BSB Number',
            accountNumber: 'Account Number',
            none: 'None',
            switchToDebit: '',
        },
        personal: 'Personal',
        business: 'Business',
        contactDetails: {
            title: 'Contact Details',
            titles: {
                mr: 'Mr',
                mrs: 'Mrs',
                miss: 'Miss',
                ms: 'Ms',
                dr: 'Dr',
            },
            commercial: 'Please enter your company name and company registration number. You must be authorised to act on behalf of the company.',
            company: 'Company Name',
            companyNumber: 'Company Registration Number',
            licencePlate: 'License Plate Number',
        },
        alternateContactDetails: {
            title: 'Alternate Contact Details',
            subtitle: 'This information allows us to contact someone if we are unable to contact you.',
            sameAddress: 'Use the same address as above',
        },
        accountDetails: {
            title: 'Account Details',
            copy: 'Must be 8 to 20 characters in length, contain at least one uppercase and lowercase character and at least one number. This password will allow you to login and pay your account online after move-in.',
            password: 'Online Password',
            confirmPassword: 'Confirm Online Password',
        },
        reservationWithFee: {
            orderNumber: 'Order Number: ',
            confirmationText: 'We’ve sent you an email with all the details of your order & remember you can track your order using this app.',
        },
        reservationConfirmed: {
            title: 'Reservation Confirmed',
            subtitle: 'You will receive an email with your reservation details.',
            finaliseBooking: 'Finalise Booking Now',
        },
        findReservation: {
            title: 'Continue your move-in',
            subtitle: 'Enter your reference number to continue with your move-in.',
            inputLabel: 'Reference number',
            placeholder: 'Reference number',
            submit: 'Continue',
            notFoundError: 'We couldn\'t find a reservation with that reference number. Please check it and try again.',
        },
        insuranceCoverage: {
            title: 'Insurance Coverage',
            subtitle: 'Insurance is not included with our rent charges. We highly recommend that all customers insure their goods for peace of mind.',
            coverage: 'Coverage',
            for_up_to: 'for up to ',
            noInsuranceSelected: 'No Insurance Selected',
            manualEntryLabel: 'Declared value of goods stored',
            disclaimer: 'By ticking this box you accept and agree: that the insurance coverage option selected will cover the true replacement value of your goods declared, agree to the T&C\'s below and understand the inclusions/exclusions of the policy.',
            flatRateInsurance: 'Flat Rate Insurance',
            selfInsurance: 'Self Insurance',
            usSupply: 'Select this option if you would like US to supply insurance.',
            subTitle: 'Select this option if YOU will supply insurance',
            proofDisclaimer: 'Note: you will need to upload Proof of Insurance below to complete your booking',
            fileTypePlease: 'Please upload either a jpg, png or pdf file using the Proof of Insurance section below.',
            pickerText: '',
        },
        addressProof: {
            title: 'Proof of Address',
            subtitle: 'Upload documentation showing a proof of the address you have provided',
            fileUploadHelpText: 'Please upload a photo which has proof of your current address. Examples are bank statements, credit card statements or utility bills.',
            uploading: 'Uploading...',
            success: 'File uploaded successfully',
            error: 'Error uploading file',
        },
        insuranceProof: {
            title: 'Proof of Insurance',
            subtitle: 'Upload documentation showing a proof of insurance taken out for your declared amount',
            fileUploadHelpText: 'A passport style (head & shoulder) photo of yourself.',
            uploading: 'Uploading...',
            success: 'File uploaded successfully',
            error: 'Error uploading file',
        },
        boxShop: {
            title: 'Moving & Packing Supplies',
            outOfStock: 'Out of stock',
            pickUpLocation: 'Pickup Location',
            showAll: 'Show All',
            showLess: 'Show Less',
        },
        pricingTable: {
            title: 'Booking Summary',
            charge: 'Charge',
            amount: 'Amount',
            discount: 'Discount',
            amountDueToday: 'Amount due today',
            initialAmount: 'Initial Amount',
            subtotal: 'Subtotal',
            tax: 'Tax',
            total: 'Total',
            including: 'including',
            receipt: 'Receipt',
            totalDueToday: 'Total Due Today',
            save: 'Save',
            was: 'Was',
        },
        identityVerification: {
            title: 'Identity Verification',
            driverLicenseDetails: 'Driver License Details',
            uploadDriverLicense: 'Driver License',
            fileUploadHelpText: 'Please upload a photo of the FRONT of your drivers license or passport photo in JPG, PNG or PDF file',
            idDocumentNumber: 'ID Document Number',
        },
        paymentForm: {
            title: 'Payment',
            cardHolderName: 'Card Holder Name',
            cardHolderNamePlaceholder: 'Card Holder Name*',
            cardNumber: 'Card Number',
            cardNumberPlaceholder: 'Card Number*',
            expiry: 'Expiry',
            csv: 'CSV',
            csvPlaceholder: 'CSV*',
            csvAmexPlaceholder: 'CVC (4 digits)*',
            errors: {
                cardHolderInvalid: 'Card Holder Name is invalid',
                cardNumberInvalid: 'Card Number is invalid',
                cardNumberLuhnInvalid: 'Please check your card number. It does not appear to be valid.',
                cardExpiryInvalid: 'Card Expiry is invalid',
                cardExpiryExpired: 'Your card has expired.',
                cardCsvInvalid: 'Card CSV is invalid',
            },
        },
        bookingConfirmation: {
            title: 'Thank you for your booking',
            subtitle: 'We have sent you an email with more details, please refer to the email for further information.',
            referenceCode: 'Your reference code is: ',
            autobillError: 'Your move-in was successful, but there was an issue with your autopayment details. Please contact support.',
            merchPaymentError: 'Your move-in was successful, but there was an issue with your merchandise. Please contact support.',
            insuranceError: 'Your move-in was successful, but there was an issue assigning your insurance. Please contact support.',
            customerSurvey: {
                title: 'Customer Survey',
                subtitle: 'We really value our customer feedback and would love if you answer some quick questions below!',
                submit: 'Submit Survey',
            },
            idVerifyButtonText: 'Verify ID',
            idVerifyText: 'Please verify your ID using the button below. Alterntatively you can do this later in the app.',
        },
        marketingSurvey: {
            title: 'Customer Survey',
            subtitle: 'Help us improve our services by answering the following questions:',
            Marketing: 'Where did you hear about us?',
            MktgDistance: 'Distance from facility?',
            MktgWhy: 'Why are you storing?',
            MktgType: 'Which best describes you?',
            MktgWhat: 'What are you storing?',
            MktgReason: 'What reason are you storing with us?',
            submit: 'Submit Survey',
            defaultOption: 'Please select an option',
        },
        termsAndConditions: 'Terms and Conditions',
    },
    oauth: {
        loading: 'Loading integrations...',
        load_error: 'Error loading integrations, please try again later.',
        connecting: 'Connecting...',
    },
    error: {
        oops: 'Oops! Something went wrong',
        subtitle: 'Sorry, an unexpected error has occured.',
        general_error: 'A general error has occured, please try again or contact support',
        go_back: 'Go back',
        not_found: 'The page you requested could not be found, please check you may have mistyped the address or the page may have moved.',
        move_in_error: 'There has been an issue with the move in process, please contact support if this issue persists.',
        reservation_cancelled_title: 'This reservation has been cancelled',
        reservation_cancelled: 'The facility has cancelled this reservation, so it can no longer be paid for. Please contact the facility if you still need the unit.',
        reservation_expired_title: 'This reservation has expired',
        reservation_expired: 'This reservation is no longer held for you. Please make a new reservation to continue.',
    },
    map: {
        map: 'Map',
        booking: 'Booking',
        smaller: 'Smaller',
        bigger: 'Bigger',
        select_unit: 'Select a unit below',
        booking_card: {
            title: 'YOUR BOOKING DETAILS',
            deals: 'FACILITY DISCOUNTS & DEALS',
            select_a_deal: 'Select a deal to apply to your booking',
            different_unit: 'Select a different unit type or standard below.',
            change_size: 'Change Size',
        },
    },
    standardUnitListing: {
        detailsModal: {
            bookNowHeader: 'Book this Unit',
            sendEnquiryHeader: 'Send Enquiry',
        },
        quickSearch: 'Quick Search:',
        all: 'All',
        small: 'Small Units',
        medium: 'Medium Units',
        large: 'Large Units',
        vehicle: 'Vehicle',
        noUnitsAvailable: 'There are currently no units available',
        spaceCalculator: {
            title: 'Space Calculator',
            notSureAboutSizing: 'Not sure about sizing?',
            needHelpTitle: 'Not sure what size you need?',
            weCanHelp: 'We can help.',
            findMeASpace: 'Find me a space',
            orCall: 'or call',
            previousStep: 'Previous Step',
            intro: 'Find self storage solutions tailored to you. Please note, you do not need to fill in all fields. Just fill the ones that are relevant to you.',
            stepOne: 'Step 1:',
            stepOneTitle: 'Select your need',
            stepTwo: 'Step 2:',
            stepTwoTitle: 'Fill the information below',
            stepTwoHelp: 'Use the slider below',
            clickBoxAbove: 'Click on a box above',
            movingHouse: 'Moving House',
            extraSpace: 'Need More Space?',
            vehicleStorage: 'Vehicle Storage',
            vehicleStorageUnavailable: 'Vehicle Storage (N/A)',
            businessStorage: 'Business Storage',
            customNeeds: 'Unsure of Your Storage Needs?',
            bedrooms: 'Number of bedrooms:',
            smallRooms: 'Number of small rooms:',
            largeRooms: 'Number of large rooms:',
            garages: 'Number of garages:',
            rooms: 'Number of rooms:',
            largeItems: 'Number of large items:',
            smallItems: 'Number of small items:',
            boxes: 'Number of boxes:',
            width: 'Width ({{sizeSymbol}}):',
            length: 'Length ({{sizeSymbol}}):',
            or: 'OR',
            findUnitSize: 'Find my unit size',
        },
        unitType: {
            moreDetails: 'More Details',
            squareMeters: 'Square meters',
            size: 'Size',
            type: 'Type',
            sizeCategories: 'Size categories',
            level: 'Level',
            whatCanItFit: 'What can it fit?',
            smallUnit: 'Small Unit',
            mediumUnit: 'Medium Unit',
            largeUnit: 'Large Unit',
            callSiteManager: 'Call Site Manager',
            bookOnline: 'Book Online',
            sendEnquiry: 'Send Enquiry',
            callForAvailability: 'Call for Availability',
        },
    },
    errors: {
        10000: 'An error occurred, please try again later.',
        10001: 'Unit is already rented or is no longer available.',
        50716: 'Transaction Declined. 3D Secure Authentication Failed',
    },
};
